import { CommunityProfileAdminsEnum, UserDto } from '@sweatpals/shared';

export const AdminRolesToOrder: Record<CommunityProfileAdminsEnum, number> = {
	[CommunityProfileAdminsEnum.Admin]: 0,
	[CommunityProfileAdminsEnum.Leader]: 1,
	[CommunityProfileAdminsEnum.Volunteer]: 2,
};

export const sortAdminsByRole = (a: UserDto, b: UserDto) =>
	a.adminToCommunityProfile && b.adminToCommunityProfile
		? AdminRolesToOrder[a.adminToCommunityProfile.roleId] - AdminRolesToOrder[b.adminToCommunityProfile.roleId]
		: 0;
